
import api from "../../../../api/axios";

/**
 * Get Title & Escrow cost calculation from backend.
 * @param {Object} payload - Required body data for calculation
 * @param {Object} params - Optional params { mainid, userid, companyid }
 * @returns {Promise<Object>} API response data
 */

export const getTitleEscrowCosts = async (payload, params = {}) => {
  try {
   // const { mainid, userid, companyid } = params;

    const res = await api.post(
      `/seller-title-escrow-costs`,
      payload
    );

    //console.log("getTitleEscrowCosts response:", res.data);
    return res.data;
  } catch (error) {
    console.error("getTitleEscrowCosts error:", error);
    throw error;
  }
};

export const getStateSettings = async (params = {}) => {
  try {
    const res = await api.get(`/state-setting`, { params });
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const getNationalSettings = async (params = {}) => {
  try {
    const res = await api.get(`/national`, { params });
    return res.data;
  } catch (error) {
    throw error;
  }
};